export const GET_COLOR = 'GET_COLOR';
export const COLOR_REQUEST = 'COLOR_REQUEST';
export const CREATE_COLOR = 'CREATE_COLOR';
export const UPDATE_COLOR = 'UPDATE_COLOR';
export const DELETE_COLOR = 'DELETE_COLOR';
export const COLOR_REQUEST_FAILURE = 'COLOR_REQUEST_FAILURE';
export const GET_COLOR_PAGE = 'GET_COLOR_PAGE';
export const COLOR_REQUEST_SUCCESS = 'COLOR_REQUEST_SUCCESS';